import React from "react";
import Home from "./components/Home/Home";

function App() {
  return (
    <>
      {/* TODO: Create container for home page */}
      <Home />
    </>
  );
}

export default App;
